(function () {
  const photos = {
    trade: {
      key: 'tradeImage',
      alt: 'FIFTH & BEAM working lighting showroom corridor in Guzhen, Zhongshan',
      caption: 'Working showroom · selection corridor'
    },
    factory: {
      key: 'factoryImage',
      alt: 'FIFTH & BEAM factory display wall and packed ceiling lights in Guzhen, Zhongshan',
      caption: 'Factory floor · packed ceiling fixtures'
    },
    quality: {
      key: 'qualityImage',
      alt: 'FIFTH & BEAM illuminated ceiling light sample wall in Guzhen, Zhongshan',
      caption: 'Sample wall · illuminated review'
    }
  };

  function fillEditorialPhotos(root) {
    const scope = root?.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-fb-photo]').forEach((figure) => {
      if (figure.dataset.fbPhotoReady === 'true') return;
      const config = photos[figure.dataset.fbPhoto];
      const source = window.FifthBeamMegaMenu?.[config?.key];
      if (!config || !source) return;

      const image = document.createElement('img');
      image.src = source;
      image.alt = config.alt;
      image.width = 1600;
      image.height = 1200;
      image.loading = 'eager';

      const caption = document.createElement('figcaption');
      caption.className = 'fb-photo-caption';
      const context = document.createElement('span');
      context.textContent = config.caption;
      const place = document.createElement('span');
      place.textContent = 'Guangdong · Zhongshan · Guzhen';
      caption.append(context, place);

      figure.replaceChildren(image, caption);
      figure.dataset.fbPhotoReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fillEditorialPhotos(document));
  } else {
    fillEditorialPhotos(document);
  }

  document.addEventListener('shopify:section:load', (event) => fillEditorialPhotos(event.target));
})();
